<template>
  <div id="receiveRoot">
    <div id="tTExchangeLogDiv">
      <div id="ttExTitleDiv">
      红包明细
      </div>
      <div id="rlClose" @click="onBackClick()">x</div>
      <div id="tTExchangTypeDiv">
        <div id="elTime" style="flex:2;text-align: center;color:#212121;font-size: x-small;text-align: center;font-weight: bold;">日期</div>
        <div id="elType" style="flex:1;text-align: center;color:#212121;font-size: x-small;text-align: center;font-weight: bold;">类型</div>
        <div id="elMoney" style="flex:1;text-align: center;color:#212121;font-size: x-small;text-align: center;font-weight: bold;">金额</div>
        <div id="elState" style="flex:1;text-align: center;color:#212121;font-size: x-small;text-align: center;font-weight: bold;">状态</div>
      </div>
      <div id="tTLogContainer">
        <span v-for="(record, index) in receiveLogs" :key="record.typeid + index + ''" :index="index + ''">
          <ReceiveRecord :record="record"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiveRecord from './ReceiveRecordItem.vue';
 export default {
  props:{
    receiveLogs: [],
  },
   data () {
     return {
     }
   },
   components: {
    ReceiveRecord
   },
  methods:{
    // 隐藏兑换记录页面
    onBackClick(){
      this.$emit("hidereceivelogpage");
    }
  },
 }
</script>

<style>
#receiveRoot{
  /* background-color: aquamarine; */
  width: 100%;
  height: 70vh;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background: rgba(51,51,51,0.5);
  z-index: 2233;
}
#rlClose{
  z-index: 2233;
  width: 25px;
  height: 25px;
  line-height: 25px;
  background-color: #E6E6E6;
  float: right;
  position: absolute;
  top: -12px;
  right: -10px;
  text-align: center;
  border-radius: 25px;
  color: #484848;
}
#tTExchangeLogDiv{
  background-color: white;
  border-radius:10px;
  z-index: 2000;
  width: 90%;
  height: 200px;
  position: relative;
  display: flex;
  flex-direction: column;
  
}
#ttExTitleDiv{
  margin-top: 10px;
  background-color: white;
  color: #3E3E3E;
  font-size: small;
  font-weight: bold;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  /* border-bottom: 1px solid #B4B4B4; */
}
#tTExchangTypeDiv{
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 2px;
  margin-left: 5px;
  margin-right: 5px;
  display: flex;
  flex-direction: row;
  background-color: #E6E6E6;
}
#tTLogContainer{
  height: 40vh;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/mine/rebateTypeMoney/cashout/receivelog/V3ReceiveLog.vue